import "../Common/Common.sass";
import "./Profile.sass";

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, getProfile } from "../Firebase/Firebase";
import { useAuthState } from "react-firebase-hooks/auth";

const Profile = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [organization, setOrganization] = useState("");
  const [industry, setIndustry] = useState("");

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    const fetchProfile = async (uid:string) => {
      const userProfile = await getProfile(user.uid);
      console.log(userProfile);

      setFirstName(userProfile.firstName);
      setLastName(userProfile.lastName);
      setEmail(userProfile.email);
      setApiKey(userProfile.apiKey);
      setOrganization(userProfile.organization);
      setIndustry(userProfile.industry);
    }

    fetchProfile(user.uid)
      .catch(console.error);
  }, [user, loading]);

  return (
    <div className="Profile">
      <div className="Profile-title">Hume AI</div>
      <div className="Profile_form">
        <label>
          First Name:
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </label>
        <label>
          Last Name
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </label>
        <label>
          Email:
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          Organization:
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={organization}
            onChange={(e) => setOrganization(e.target.value)}
          />
        </label>
        <label>
          Industry:
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
          />
        </label>
        <label>
          API Key:
          <input
            type="text"
            className="Common-text-field Profile-text-field"
            value={apiKey}
            readOnly={true}
          />
        </label>
      </div>
    </div>
  );
}

export default Profile;